import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "../ui/button";

const links = [
  { href: "#oportunidad", label: "La oportunidad" },
  { href: "#como-funciona", label: "Cómo funciona" },
  { href: "#entregables", label: "Qué entregamos" },
  { href: "#faq-agencias", label: "FAQ" },
];

export default function AgenciesHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-galvani-bg/85 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-3" data-testid="agencies-logo">
          <span className="font-heading font-extrabold text-lg tracking-wider text-galvani-text">
            GALVANI
          </span>
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.2em] font-body font-semibold text-galvani-purple bg-purple-50 border border-purple-200 rounded-full px-2 py-1">
            Partners
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-body text-sm text-galvani-textLight hover:text-galvani-purple transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a href="#solicitar-propuesta" className="hidden sm:block">
            <Button
              className="bg-gradient-to-r from-galvani-blue to-galvani-purple hover:opacity-90 text-white font-body font-semibold rounded-full h-10 px-5 shadow-md"
              data-testid="agencies-header-cta"
            >
              Más información
            </Button>
          </a>
          <button
            className="md:hidden p-2 text-galvani-text"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menú"
            data-testid="agencies-menu-toggle"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-3">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block font-body text-sm text-galvani-text"
            >
              {l.label}
            </a>
          ))}
          <a href="#solicitar-propuesta" onClick={() => setOpen(false)}>
            <Button className="w-full bg-gradient-to-r from-galvani-blue to-galvani-purple text-white font-body font-semibold rounded-full h-11">
              Más información
            </Button>
          </a>
        </div>
      )}
    </header>
  );
}
